// extracted by mini-css-extract-plugin
export var disabled = "_w-a";
export var hierarchyLinkGray = "_w-4";
export var hierarchyLinkUnderline = "_w-3";
export var hierarchyPrimary = "_w-0";
export var hierarchySecondary = "_w-1";
export var hierarchyTertiary = "_w-2";
export var pressed = "_w-6";
export var themeAction = "_w-5";
export var themeDestructive = "_w-8";
export var themeNormal = "_w-7";
export var themeSuccess = "_w-9";